import {
  DataTable,
  Dialog,
  Heading,
  Loader,
  MonthlyDistribution,
} from "@/components";
import useLineItems from "./useLineItems";
import { Button, Input } from "@/components/ui";
import { Search } from "lucide-react";

const LineItems = () => {
  const {
    breadcrumbData,
    isMobile,
    onAdd,
    globalFilter,
    setGlobalFilter,
    onRowClick,
    columns,
    openDeleteDialog,
    setOpenDeleteDialog,
    isDeletePending,
    onDeleteConfirm,
    rowSelected,
    isLineItemDataLoading,
    lineItems,
    openDistributionDialog,
    setOpenDistributionDialog,
    onSaveMonthlyDistribution,
    isDraft,
    isLimitLoading,
    onBackClick,
    isBudgetDataLoading,
    _budgetData,
    isArchived
  } = useLineItems();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title={`Line Items`}
            breadcrumbData={breadcrumbData}
            showBack
            onBackClick={onBackClick}
          />
          {isDraft && isMobile && (
            <Button onClick={onAdd} className="px-2">
              + Add
            </Button>
          )}
        </div>
        <div className="flex flex-row items-center gap-4">
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
          {!isMobile && isDraft && <Button onClick={onAdd}>+ Add</Button>}
        </div>
      </div>

      {/* Responsive Table */}
      {isLineItemDataLoading || isLimitLoading || isBudgetDataLoading ? (
        <Loader />
      ) : (
        <>
          <p className="mb-3 text-sm text-primary font-bold">
            Financial Year: {_budgetData?.data?.year} Version (
            {_budgetData?.data?.versionNo})
          </p>

          {isArchived && <div className="text-stone-600 bg-amber-50 border-yellow-400 border-1 p-5 text-[12px] rounded-[10px] my-[20px]">
            <div className="italic my-3">
              <span className="font-semibold">This budget is a revision of an already approved budget.</span>
              <ul className="list-disc pl-4">
                <li>Financial posting is currently blocked.</li>
                <li>Any budget line item with posted financial documents cannot be deleted.</li>
                <li>You may edit existing GL lines or add new GL lines.</li>
              </ul>
            </div>
            <span className="font-semibold">Submit the budget for BM approval once revisions are complete.</span>
          </div>}

          <DataTable
            columns={columns}
            data={(lineItems?.data?.slice() || [])?.sort(
              (a: any, b: any) =>
                new Date(b.updatedAt).getTime() -
                new Date(a.updatedAt).getTime()
            )}
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
            onRowClick={onRowClick}
          />
          {/* Delete Dialog */}
          {openDeleteDialog && (
            <Dialog
              open={openDeleteDialog}
              setOpen={setOpenDeleteDialog}
              title={
                <div className="text-2xl font-bold text-primary">
                  {"Confirmation"}
                  <div className="h-1 w-[30%] bg-primary rounded-full" />
                </div>
              }
              saveText="Delete"
              saveBtnClassName="bg-red-500 text-white hover:bg-red-500 hover:text-white"
              isLoading={isDeletePending}
              onSave={onDeleteConfirm}
            >
              <p className="text-sm">
                Are you sure you want to delete this line item? This action
                cannot be undone.
              </p>
            </Dialog>
          )}
        </>
      )}
      {openDistributionDialog && rowSelected && (
        <MonthlyDistribution
          openDistributionDialog={openDistributionDialog}
          setOpenDistributionDialog={setOpenDistributionDialog}
          annualBudget={rowSelected?.budgetYearlyAmt}
          onSave={onSaveMonthlyDistribution}
          rowSelected={rowSelected}
        />
      )}
    </div>
  );
};

export default LineItems;
